var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomModal', {
    attrs: {
      "customClass": "generic-modals v--modal new-modal",
      "height": "auto",
      "name": "ugcPlacementWarningModal",
      "width": "92%",
      "clickToClose": false
    },
    on: {
      "beforeOpen": _vm.beforeOpenModal
    }
  }, [_c('CustomContainer', {
    staticClass: "new-modal-wrapper customs-tools",
    attrs: {
      "elementType": "section"
    }
  }, [_c('ModalHeader', {
    attrs: {
      "backDisabled": true,
      "buttonText": true,
      "headerImg": true
    },
    on: {
      "closeEvent": _vm.closeAction
    }
  }), _c('CustomContainer', {
    staticClass: "new-modal-main-views-wrapper",
    attrs: {
      "elementType": "section"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "elementType": "div"
    }
  }, [_c('CustomContainer', {
    staticClass: "new-modal-error-icon",
    attrs: {
      "elementType": "div"
    }
  }, [_vm._v(" ! ")]), _c('CustomText', {
    attrs: {
      "customClass": "new-modal-title",
      "elementType": "h2",
      "text": _vm.title
    }
  }), _c('CustomText', {
    attrs: {
      "customClass": "new-modal-description",
      "elementType": "p",
      "text": _vm.description
    }
  })], 1)], 1), _c('CustomContainer', {
    staticClass: "new-modal-button-nav"
  }, [_c('CustomButton', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isApparel,
      expression: "!isApparel"
    }],
    attrs: {
      "customClass": "new-modal-button-nav-container-cta expanded secondary",
      "type": "button",
      "keyTranslation": "placementWarningGoBack"
    },
    on: {
      "click": _vm.closeAction
    }
  }), _c('CustomButton', {
    attrs: {
      "customClass": "new-modal-button-nav-container-cta expanded primary",
      "type": "button",
      "keyTranslation": _vm.isApparel ? 'apparelPlacementWarningGoBack' : 'placementWarningContinue'
    },
    on: {
      "click": _vm.onContinue
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }